module.exports = __webpack_public_path__ + "img/upload.132cb0d6.png";